import { TeamData } from 'config/commonTypes';
import React from 'react';
import { useEntitiesState } from 'store/hooks';
import {
  POSITION,
  STATUS,
  OFFICIALS_POSITIONS,
  POSITION_LACROSSE
 } from '../../config/constants';

import { getTeamData } from '../../helpers/helpers';
import BasicDropdown from '../Shared/BasicDropdown/BasicDropdown';
import { ExtraDataFormProps, PositionLacrossType, PositionOfficialsType } from './types';

// need to pass the missing functions for this part to be complete.
const ExtraDataForm = ({
                  changeNflId, changeFirstName, changeLastName,
                  changeJerseyNumber, changeHeight, changeWeight,
                  changeBirthday,
                  changeCollegeName,
                  entity, extraData, teamId, setExtraData, addEntity, changeStats
                }:ExtraDataFormProps) => {
  let teamData;
  if (extraData && extraData.teamId !== '') {
    teamData = getTeamData(extraData.teamId)||{} as TeamData;;
  } else {
    teamData = getTeamData(teamId)||{} as TeamData;;
  }
  const noValueChange = () => {
  };

  const { isNcaaLeague } = useEntitiesState();
  const entityIsOfficial = entity && entity.type === 'official';

  return (
    <div className="ex-entities">
      {!entityIsOfficial && <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              id='team_full_name'
              className="material-input no-asterisk" required
              value={teamData ? teamData.teamFullName : ''}
              onChange={() => noValueChange()}
            />
            <span className="material-label">Team Full Name</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              id='team_id'
              className="material-input" required
              value={extraData && extraData.teamId ? extraData.teamId : teamId}
              onChange={() => noValueChange()}
            />
            <span className="material-label">Team ID</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              id='team_abbreviation'
              className="material-input" required
              value={teamData ? teamData.teamAbbrName : ''}
              onChange={() => noValueChange()}
            />
            <span className="material-label">Team Abbreviation</span>
          </div>
        </div>
      </div>}

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              id='nfl_id'
              className={`material-input ${isNcaaLeague? 'no-asterisk' : ''}`}
              value={extraData && extraData.nflId &&
                //@ts-ignore
              (!isNaN(extraData.nflId) || extraData.nflId === '')
                ? extraData.nflId : ''}
              onChange={(event) => changeNflId(event)}
            /> 
            <span className="material-label">NFL ID</span>
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              id='first_name'
              className="material-input" required
              value={extraData ? extraData.firstName : ''}
              onChange={(event) => changeFirstName(event)}
            />
            <span className="material-label">First Name</span>
          </div>
        </div>
        <div>
          <div className="material-textbox" id="first-name-input">
            <input
              id='last_name'
              className="material-input" required
              value={extraData ? extraData.lastName : ''}
              onChange={(event) => changeLastName(event)}
            />
            <span className="material-label">Last Name</span>
          </div>
        </div>
      </div>

      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox" id="first-name-input">
            <input
              id='jersey_number'
              className="material-input" required
              value={extraData && extraData.jerseyNumber?.toString()? extraData.jerseyNumber : ''}
              onChange={(event) => changeJerseyNumber(event)}
            />
            <span className="material-label">Jersey #</span>
          </div>
        </div>
        {!entityIsOfficial ?
          <div className="d-entities-t">
            <div className="material-textbox" id="first-name-input">
              <input
                id='height'
                className="material-input no-asterisk" required
                value={extraData ? extraData.height : ''}
                onChange={(event) => changeHeight(event)}
              />
              <span className="material-label">Height</span>
            </div>
          </div> :
          <div style={{width: '231px', position: 'relative'}}>
            <span className="label-select"> Position  </span>
            <b style={{
              position: 'absolute',
              right: '5px',
              top: '-16px',
              color: 'red',
              fontSize: '11px'
            }}>*</b>
            <BasicDropdown
              type={OFFICIALS_POSITIONS}
              selectedType={OFFICIALS_POSITIONS.types.find(type => type.value.position === (extraData && extraData.position))}
              onSelectType={(itemsSelected:PositionOfficialsType) => {
                const newExtraData = JSON.parse(JSON.stringify(extraData));
                newExtraData.position = itemsSelected.value.position;
                newExtraData.positionGroup = itemsSelected.value.group;
                setExtraData(newExtraData);
              }}
            />
          </div>
        }
        {!entityIsOfficial && <div>
          <div className="material-textbox" id="first-name-input">
            <input
              id='weight'
              className="material-input no-asterisk" required
              value={extraData ? extraData.weight : ''}
              onChange={(event) => changeWeight(event)}
            />
            <span className="material-label">Weight</span>
          </div>
        </div>}
      </div>

      {!entityIsOfficial && <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox">
            <input
              id='birthday'
              className="material-input no-asterisk"
              value={extraData ? extraData.birthDate : ''}
              onChange={(event) => changeBirthday(event)}
              required
            />
            <span className="material-label">Birthday</span>
          </div>
        </div>
        {/*  IF MLAX DO NOT SHOW THIS*/}
        {teamData.league === 'ncaa-mlax'? 
        ''
        :
        <div className="d-entities-t">
          <div className="material-textbox">
            <input
              id='position_group'
              className="material-input"
              readOnly
              value={!addEntity? extraData? extraData.positionGroup === ''? POSITION.types.find(position => position.name === extraData.position)?.value.group :
              extraData.positionGroup: '' : extraData.positionGroup } />
            <span className={'material-label ' + (addEntity && extraData.positionGroup === '' ? 'out-focus' :'in-focus')}>
              Position Group
            </span>
          </div>
        </div>
        }
        <div style={{width: '100%', position: 'relative'}}>
            <span className="label-select"> Position  </span>
            <b style={{
              position: 'absolute',
              right: '6px',
              top: '-16px',
              color: 'red',
              fontSize: '11px'
            }}>*</b>
            {/* IS MLAX */}
            {teamData.league === 'ncaa-mlax'?

             <BasicDropdown
             type={{
              name: 'table-header-location',
              types: POSITION_LACROSSE.types,
              title: 'LOCATION'
            }}
             selectedType={POSITION_LACROSSE.types.find(type => type.value === (extraData && extraData.position))}
             onSelectType={(itemsSelected: PositionLacrossType) => {
               const newExtraData = JSON.parse(JSON.stringify(extraData));
               newExtraData.position = itemsSelected.value;
               setExtraData(newExtraData);
             }}

           />
            : 
            <BasicDropdown
            type={POSITION}
            selectedType={POSITION.types.find(type => type.value.position === (extraData && extraData.position))}
            onSelectType={(itemsSelected: PositionOfficialsType) => {
              const newExtraData = JSON.parse(JSON.stringify(extraData));
              newExtraData.position = itemsSelected.value.position;
              newExtraData.positionGroup = itemsSelected.value.group;
              setExtraData(newExtraData);
            }}
          />
            }        
        </div>
      </div>}

      {!entityIsOfficial && <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox">
            <input className="material-input no-asterisk" required  id='years_of_experience'/>
            <span className="material-label">Years of Experience</span> {/*MISSING INPUT HANDLING, */}
          </div>
        </div>
        <div className="d-entities-t">
          <div className="material-textbox">
            <input
              id='college'
              className="material-input no-asterisk"
              required
              value={extraData ? extraData.collegeName : ''}
              onChange={event => changeCollegeName!(event)}
            />
            <span className="material-label">College</span>
          </div>
        </div>
        <div style={{width: '100%', position: 'relative'}}>
            <span className="label-select"> Status </span>
            <b style={{
              position: 'absolute',
              right: '6px',
              top: '-16px',
              color: 'red',
              fontSize: '11px'
            }}>*</b>
            <BasicDropdown
              type={STATUS}
              selectedType={STATUS.types.find(type => type.value === (extraData && extraData.status))}
              onSelectType={(itemsSelected:{name:string; value:string}) => {
                const newExtraData = JSON.parse(JSON.stringify(extraData));
                newExtraData.status = itemsSelected.value;
                setExtraData(newExtraData);
              }}
            />
        </div>
       
      </div>}
      <div className="m-entities-t">
        <div className="d-entities-t">
          <div className="material-textbox">
            <input
              id='stats'
              required
              className="material-input no-asterisk"
              value={extraData ? extraData.stats : ''}
              onChange={event => changeStats!(event)}/>
            <span className="material-label">Stats</span>
          </div>
        </div>
        </div> 
    </div>
  );
};

export default ExtraDataForm;
